"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Themes;
(function (Themes) {
    Themes["Teams"] = "teams";
    Themes["Light"] = "light";
})(Themes = exports.Themes || (exports.Themes = {}));
var AppIds;
(function (AppIds) {
    AppIds["Meetings"] = "wl";
    AppIds["OffSkypeInvites"] = "oi";
})(AppIds = exports.AppIds || (exports.AppIds = {}));
var Actions;
(function (Actions) {
    Actions["Chat"] = "chat";
    Actions["Call"] = "call";
})(Actions = exports.Actions || (exports.Actions = {}));
exports.defaultDimension = { width: 0, height: 0 };
exports.mainContentId = 'mainContent';
